import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export default async campaignId => {
  const query = `query ($campaignId:ID!){
     campaign(id:$campaignId){
       pitchUrl
     }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/ClientQuestions/gql.js